/**
 * ISO-6166-Prüfziffer für eine ISIN (Luhn-Algorithmus auf die buchstaben-zu-zahlen-
 * übersetzte ISIN, A=10..Z=35) - gegen fünf echte, bekannte ISINs verifiziert (Apple,
 * SAP, Microsoft, Tesla, ein iShares-ETF mit Buchstabe in der mittleren Kennnummer).
 * Ursprünglich in lib/dividend-tracker/import/parse-dividend-receipt-text.ts entstanden,
 * hierher ausgelagert (2026-07-29), da die Depot-Kaufabrechnungs-Erkennung dieselbe
 * Prüfung braucht (siehe lib/portfolio/import/parse-purchase-receipt-text.ts) - eine
 * Quelle statt zweier driftender Kopien. Reine Funktion.
 */
export function isValidIsinChecksum(isin: string): boolean {
  if (!/^[A-Z]{2}[A-Z0-9]{9}\d$/.test(isin)) return false;
  const expanded = isin
    .slice(0, -1)
    .split("")
    .map((ch) => (/[A-Z]/.test(ch) ? String(ch.charCodeAt(0) - 55) : ch))
    .join("");
  let sum = 0;
  let doubleDigit = true;
  for (let i = expanded.length - 1; i >= 0; i--) {
    let digit = Number(expanded[i]);
    if (doubleDigit) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
    doubleDigit = !doubleDigit;
  }
  const checkDigit = (10 - (sum % 10)) % 10;
  return checkDigit === Number(isin.slice(-1));
}
